module.exports = __webpack_public_path__ + "img/calendar.9c781cb5.svg";